<template>
  <div class="app-loading" v-if="isLoading">
    <div class="hollow-dots-spinner">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const isLoading = computed(() => store.state.isLoading);
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/loading";
</style>
